// @flow

import * as React from 'react';

type Props = {|
    content: string
|};

const Badge = ({ content }: Props): React.Node => (
    <span className="Badge">{content}</span>
);

export default Badge;
